function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import _ from "lodash";
import { isInputInvalid } from "../../../../helpers/errorUtils";
import { AvInput } from "availity-reactstrap-validation";

class TmInput extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      const {
        field,
        errorKey,
        fieldGroup,
        value,
        children,
        colored,
        ...config
      } = this.props;
      return /*#__PURE__*/React.createElement(AvInput, _extends({
        id: !!fieldGroup ? `${fieldGroup.replace(/\w+/g, _.capitalize)}[${_.camelCase(field)}]` : _.camelCase(field)
      }, config, {
        name: !!fieldGroup ? `${fieldGroup.replace(/\w+/g, _.capitalize)}[${_.camelCase(field)}]` : _.camelCase(field),
        invalid: isInputInvalid(this.props.error, _.camelCase(errorKey || field)),
        value: !!value ? value : this.props.type === 'number' ? '0' : ''
      }), children);
    });
  }

}

export default TmInput;